import { ArrowLeft, TickCircle } from "iconsax-reactjs";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import CTAs from "../../components/CTAs";
import Footer from "../../components/Footer";

const RegistrationCompletedPage = () => {
  const navigate = useNavigate();

  const handleContinue = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&display=swap');

        html, body {
          margin: 0;
          background: #ffffff !important;
        }

        .dd-root {
          font-family: 'DM Sans', sans-serif;
          background: #ffffff;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 20px;
        }

        .dd-form-container {
          width: 400px;
          max-width: 100%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          gap: 24px;
          margin: auto;
        }

        .dd-section-label {
          font-size: 14px; font-weight: 700; color: #0F172A;
          margin-bottom: 6px; display: block;
        }

        .dd-text {
          font-size: 13px; color: #64748B; line-height: 1.6;
        }

        .dd-link {
          font-size: 13px; font-weight: 600; color: #2563EB;
          text-decoration: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center; gap: 8px;
        }
        .dd-link:hover { text-decoration: underline; }

        .dd-icon-circle {
          width: 48px; height: 48px; border-radius: 8px;
          background: #F8FAFC; border: 1px solid #E2E8F0;
          display: flex; align-items: center; justify-content: center;
          margin-bottom: 8px;
        }
      `}</style>

      <div className="dd-root">
        <div className="dd-form-container">
          {/* Success icon + heading */}
          <div style={{ textAlign: "center" }}>
            <div className="dd-icon-circle" style={{ margin: "0 auto 16px" }}>
              <TickCircle size={20} color="#2563EB" />
            </div>
            <h1
              style={{
                fontSize: "24px",
                fontWeight: 700,
                color: "#0F172A",
                margin: "0 0 8px 0",
              }}
            >
              Registration completed
            </h1>
            <p className="dd-text">
              Your registration has been successfully completed.
              <br />
              Click below to log in manually.
            </p>
          </div>

          {/* Continue button */}
          <CTAs
            type="Signinbtn"
            text="Continue"
            width="100%"
            onClick={handleContinue}
          />

          {/* Back to login link */}
          <div style={{ textAlign: "center" }}>
            <span className="dd-link" onClick={handleContinue}>
              <ArrowLeft size={18} />
              Back to login
            </span>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default RegistrationCompletedPage;
